// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"845":"6aef0846","2812":"6aef0846","4281":"320223a5","6334":"59b1514f","7104":"bbdcab5c"}[chunkId] + ".chunk.css";
};